export default __webpack_public_path__ + "static/media/ai.a86f743a.svg";